const viewIds = {
  OVERVIEW: 'overview',
  DOCUMENTS: 'documents',
  ENTITIES: 'entities',
  XREF: 'xref',
  DIAGRAMS: 'diagrams',
  MAPPINGS: 'mappings',
  MENTIONS: 'mentions',
  SEARCH: 'search',
  LISTS: 'lists',
  TIMELINES: 'timelines',
};

export default viewIds;
